module.exports = __webpack_public_path__ + "img/72.5aeab4b0.jpg";